module.exports = __webpack_public_path__ + "img/DSC_1085.13918230.jpg";